export const SET_SELECTED_SIDE_MENU = "SET_SELECTED_SIDE_MENU";
